import { createSlice } from '@reduxjs/toolkit';

interface IInitialState {
  message: any;
  hasError: boolean;
}

const initialState: IInitialState = {
  message: null,
  hasError: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError(state, action) {
      state.message = action.payload;
      state.hasError = true;
    },
    clearError(state) {
      state.message = null;
      state.hasError = false;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;

export default errorSlice.reducer;
